import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import BgImg from "../../../images/case-studies/soundly/discover_section.webp";

function Discover() {
  return (
    <div
      className="discover_section p-100"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto my-md-0">
            <h1 class="h2">Discover the Undiscovered, All Around with Soundly</h1>
            <p>
              Soundly has revolutionized the way people experience
              music.Designed to enable music lovers to stream millions of songs
              from new artists through the app, the Soundly app lets you save
              songs for later by creating countless playlists, uploading your
              own tracks, supporting your favorite artists, and experiencing a
              next-gen technology and music collaboration in perfect harmony.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Discover;
